import { Pipe, PipeTransform } from '@angular/core';
import { mapProductId } from '@epicuro-next/utilities';

@Pipe({
  name: 'productId',
  standalone: true,
})
export class ProductIdPipe implements PipeTransform {
  public transform = mapProductId;
}
